/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClosedLot } from './ClosedLot';
import {
    ClosedLotFromJSON,
    ClosedLotFromJSONTyped,
    ClosedLotToJSON,
} from './ClosedLot';

/**
 * 
 * @export
 * @interface ClosedLotsPage
 */
export interface ClosedLotsPage {
    /**
     * 
     * @type {Array<ClosedLot>}
     * @memberof ClosedLotsPage
     */
    lots: Array<ClosedLot>;
    /**
     * 
     * @type {number}
     * @memberof ClosedLotsPage
     */
    totalNr: number;
}

/**
 * Check if a given object implements the ClosedLotsPage interface.
 */
export function instanceOfClosedLotsPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lots" in value;
    isInstance = isInstance && "totalNr" in value;

    return isInstance;
}

export function ClosedLotsPageFromJSON(json: any): ClosedLotsPage {
    return ClosedLotsPageFromJSONTyped(json, false);
}

export function ClosedLotsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClosedLotsPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lots': ((json['lots'] as Array<any>).map(ClosedLotFromJSON)),
        'totalNr': json['total_nr'],
    };
}

export function ClosedLotsPageToJSON(value?: ClosedLotsPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lots': ((value.lots as Array<any>).map(ClosedLotToJSON)),
        'total_nr': value.totalNr,
    };
}

